export default "/assets/8ab0bbdd48f276f4ba5652b27ae59210.woff";